<div tabindex="0" class="me-register-warning-card" *ngIf="data">
    <div class="me-register-warning-card__header">
        {{data.title}}
    </div>
    <div class="me-register-warning-card__body"  [innerHTML]="data.paragraph | storyblokRichtext">
    </div>
    <div class="me-register-warning-card__note">
        {{ 'I credibly affirm that I will not harm myself or others at this time.' | translate}}
    </div>
    <div class="me-register-warning-card__button">
        <button class="btn btn--primary" (click)="meRegisterService.step = 2;">
            {{ 'Continue' | translate}}
        </button>
    </div>
</div>